import React from 'react';
import { Router } from "./routing/Router";

function App ()
{
	return <Router/>;
}

export default App;
